import React from 'react';
import { Handshake } from '@phosphor-icons/react';

interface SessionStatsData {
    completedEngagements: number;
    activeEngagements: number;
    totalSessionsDelivered: number;
    avgCoacheeProgress: number;
    totalCoachees: number;
    engagementCompletionRate: number;
}

interface CoachSessionStatsWidgetProps {
    data?: SessionStatsData[] | null;
    loading?: boolean;
    error?: string;
}

interface StatCardProps {
    value: string;
    label: string;
    bgClass: string;
    textClass: string;
}

const StatCard: React.FC<StatCardProps> = ({ value, label, bgClass, textClass }) => (
    <div className={`text-center p-3 ${bgClass} rounded-lg`}>
        <div className={`text-xl font-bold ${textClass}`}>{value}</div>
        <div className="text-[10px] text-gray-400 mt-0.5">{label}</div>
    </div>
);

export const CoachSessionStatsWidget: React.FC<CoachSessionStatsWidgetProps> = ({ data, loading, error }) => {
    const row = Array.isArray(data) ? data[0] : null;

    return (
        <div className="flex flex-col h-full p-5">
            <div className="flex-1">
                {loading ? (
                    <div className="flex items-center justify-center h-full">
                        <div className="w-6 h-6 border-3 border-gray-200 border-t-primary rounded-full animate-spin" />
                    </div>
                ) : error ? (
                    <div className="flex items-center justify-center h-full text-red-500 text-sm">{error}</div>
                ) : !row ? (
                    <div className="flex flex-col items-center justify-center h-full text-gray-400 gap-2">
                        <Handshake className="w-8 h-8" />
                        <span className="text-sm">No coaching data</span>
                    </div>
                ) : (
                    <div className="grid grid-cols-3 gap-3">
                        <StatCard value={String(Number(row.totalSessionsDelivered) || 0)} label="Sessions Delivered" bgClass="bg-cyan-50" textClass="text-cyan-700" />
                        <StatCard value={String(Number(row.activeEngagements) || 0)} label="Active Engagements" bgClass="bg-emerald-50" textClass="text-emerald-600" />
                        <StatCard value={`${Number(row.avgCoacheeProgress) || 0}%`} label="Avg Progress" bgClass="bg-amber-50" textClass="text-amber-600" />
                        <StatCard value={String(Number(row.totalCoachees) || 0)} label="Total Coachees" bgClass="bg-blue-50" textClass="text-blue-600" />
                        <StatCard value={String(Number(row.completedEngagements) || 0)} label="Completed" bgClass="bg-purple-50" textClass="text-purple-600" />
                        <StatCard value={`${Number(row.engagementCompletionRate) || 0}%`} label="Completion Rate" bgClass="bg-emerald-50" textClass="text-emerald-600" />
                    </div>
                )}
            </div>
        </div>
    );
};
